import { Icon } from '@iconify/react/dist/iconify.js';
import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import SuccessAlert from '../child/Alert/SuccessAlert';
import DengerAlert from '../child/Alert/DengerAlert';

import { handleUnauthorized,showConfirmationDialog} from '../../utils/apiHelper';

const SupportTicketListLayer = () => {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const [searchQuery, setSearchQuery] = useState('');
  const [totalPages, setTotalPages] = useState(1);
  const [totalItems, setTotalItems] = useState(0);
  const [itemsPerPage, setItemsPerPage] = useState(10); // Dynamically adjustable items per page
  const [successMessage, setSuccessMessage] = useState(""); // Manage Success Message
  const [errorMessage, setErrorMessage] = useState(""); // Manage Success Message
  const [showModal, setShowModal] = useState(false);
  const [errors, setErrors] = useState({});
  const [adminId, setAdminId ] = useState("");
  const [TicketId, setTicketId ] = useState("");
  const [SelectTicketData, setSelectTicketData ] = useState("");
  const [subadminData, setsubadminData] = useState([]); // Track selected items
  const [selcetedadmin, setselectedadmin] = useState(""); // Track selected items    
  const navigate = useNavigate();
   const [sortColumn, setSortColumn] = useState("createdAt");
   const [sortOrder, setSortOrder] = useState("desc");
  const authToken = localStorage.getItem('authToken');
    useEffect(() => {
      
       const fetchAdminData = async () => {
      
            setLoading(true);
            try {
              const response = await fetch(
                `${process.env.REACT_APP_BASE_URL}/admin/supportAdminList`,
                {
                  method: "GET",
                  headers: { Authorization: `Bearer ${authToken}` },
                }
              );
              if (response.status === 401) {
                handleUnauthorized(navigate);
                return;
              }
              const data = await response.json();
              const allAdmins = data.supportAdmins || [];
              const filteredAdmins = allAdmins.filter(admin =>
                admin.permissions.some(
                  permission =>
                    permission.moduleName?.toLowerCase() === "supportticket"
                )
              );
            
              setsubadminData(filteredAdmins || []);
            } catch (error) {
              setErrorMessage("Error fetching sub admindata");
              clearMessage();
            } finally {
              setLoading(false);
            }
          };
      fetchAdminData();
      fetchData(currentPage);
    }, [currentPage, searchQuery, itemsPerPage,sortOrder,sortColumn]);
    const clearMessage = () => {
      setTimeout(() => {
        setSuccessMessage("");
        setErrorMessage("");
      }, 3000);
    };
    const fetchData = async (page) => {
     
        const API_ENDPOINT = `${process.env.REACT_APP_BASE_URL}/admin/helpSupportList?page=${page}&limit=${itemsPerPage}&sort=${sortColumn}&order=${sortOrder}&search=${searchQuery}`;
        try {
          setLoading(true);
          const response = await fetch(API_ENDPOINT, {
            method: 'GET',
            headers: {
              'Content-Type': 'application/json',
              Authorization: `Bearer ${authToken}`,
            },
          });
          if (response.status === 401) {
            handleUnauthorized(navigate);;
            return;
          }
          if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
          }
          const data = await response.json();

          setItems(data.result || []);
         setTotalItems(data.metadata.totalEntries || 0);
          setTotalPages(data.metadata.totalPages || 1);
        } catch (error) {
          setItems([]);
        } finally {
          setLoading(false);
        }
      };
      const handlePageChange = (pageNumber) => { 
        if (pageNumber >= 1 && pageNumber <= totalPages) {
          setCurrentPage(pageNumber);
        }
      };
      const handleItemsPerPageChange = (e) => {
        setItemsPerPage(parseInt(e.target.value, 10));
        setCurrentPage(1); // Reset to the first page on items per page change
      };
      const handleSort = (column) => {
        setSortColumn(column);
        setSortOrder((prevOrder) => (prevOrder === "asc" ? "desc" : "asc"));
      };
      const closeModel = () =>{
        setShowModal(false);
        setSelectTicketData("");
      }
     const updateStatus = async (id, currentStatus) => {
        const newStatus = currentStatus === 'Open' ? 'Resolved' : 'Open';
        const message = `Do you want to change the status to ${newStatus}?`;
        const result = await showConfirmationDialog(message);
        if (result.isConfirmed) {
          try {
            const API_ENDPOINT = `${process.env.REACT_APP_BASE_URL}/admin/helpSupportAdminResponse/${id}`;
            const response = await fetch(API_ENDPOINT, {
              method: 'PUT',
              headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${authToken}`,
               
              },
              body: JSON.stringify({ status: newStatus , adminResponse:"Resolved the issue" }),
            });
            if (response.status === 401) {
              handleUnauthorized(navigate);;
              return;
            }
            if (!response.ok) {
              throw new Error(`HTTP error! status: ${response.status}`);
            }
            setSuccessMessage("Ticket status updated successfully!");
          setTimeout(() => {
            setSuccessMessage("");
          }, 3000);
         
          fetchData(currentPage);
          } catch (error) {
            setErrorMessage(error.message);
            setTimeout(() => {
              setErrorMessage("");
            }, 3000);
                }
        }
      };
      const assigntoadmin = async (selcetedadmin,ticketId) => {
        setLoading(true);
        if (!validateInputs()) {
          setLoading(false);
          return;
        }
            try {
                     
                      const API_ENDPOINT = `${process.env.REACT_APP_BASE_URL}/admin/assign-help-support-ticket/${ticketId}`;
                      const response = await fetch(API_ENDPOINT, {
                        method: 'PUT',
                        headers: {
                          'Content-Type': 'application/json',
                          Authorization: `Bearer ${authToken}`,
                         
                        },
                        body: JSON.stringify({ ticketId: ticketId ,adminId:selcetedadmin}),
                      });
                      if (response.status === 401) {
                        handleUnauthorized(navigate);;
                        return;
                      }
                      if (!response.ok) {
                        throw new Error(`HTTP error! status: ${response.status}`);
                      }
                      setSelectTicketData("");
                      setShowModal(false);
                      setSuccessMessage(`Ticket has been successfully assigned to the sub admin!`);
                    setTimeout(() => {
                      setSuccessMessage("");
                    }, 3000);
                  
                    fetchData(currentPage);
                    } catch (error) {
                      setErrorMessage(error.message);
                      setTimeout(() => {
                        setErrorMessage("");
                      }, 3000);
                          }
      }
                  const validateInputs = () => {
                  const newErrors = {};
                  if (!selcetedadmin) {
                    newErrors.selcetedadmin = "Please select admin";
                  }
                  setErrors(newErrors);
                  return Object.keys(newErrors).length === 0;
                };
                const storedPermissions = JSON.parse(localStorage.getItem("permissions") || "[]");
                const SpacetypePermissions = storedPermissions.find(
                  (perm) => perm.moduleName === "supportticket"
                );
      const canView = SpacetypePermissions?.view || false;
      const canDelete = SpacetypePermissions?.delete || false;
      const canEdit = SpacetypePermissions?.edit || false;
      const canAdd = SpacetypePermissions?.add || false;
      const userrole = localStorage.getItem("user_role");
    
      const shouldCheckPermissions = userrole === "support_admin";
      const getPaginationRange = () => {
        let start = Math.max(1, currentPage - 2);
        let end = Math.min(totalPages, start + 4); // Ensure only 5 items are shown (start + 4)
      
        if (end - start < 4) {
          start = Math.max(1, end - 4);
        }
      
        return Array.from({ length: end - start + 1 }, (_, index) => start + index);
      };
      const handleNext = () => {
        if (currentPage < totalPages) {
          setCurrentPage((prev) => prev + 1);
        }
      };
      const handlePrev = () => {
        if (currentPage > 1) {
          setCurrentPage((prev) => prev - 1);
        }
      };
    return (
        <div className="card h-100 p-0 radius-12">
            {successMessage && <SuccessAlert message={successMessage} onClose={() => setSuccessMessage("")} />}
            {errorMessage && <DengerAlert message={errorMessage} onClose={() => setErrorMessage("")} />}
            <div className="card-header border-bottom bg-base py-16 px-24 d-flex align-items-center flex-wrap gap-3 justify-content-between">
                <div className="d-flex align-items-center flex-wrap gap-3">
                    <span className="text-md fw-medium text-secondary-light mb-0"  
                   >Show</span>
                    <select className="form-select form-select-sm w-auto ps-12 py-6"    style={{fontSize:"16px" ,borderRadius:"7px",backgroundPositionX: "unset", backgroundPosition: "right 0.75rem center" }}  value={itemsPerPage} defaultValue="Select Number"  onChange={handleItemsPerPageChange}>   
                        <option value="10">10 items per page</option>
                        <option value="20">20 items per page</option>
                        <option value="50">50 items per page</option>
                        <option value="100">100 items per page</option>
                    </select>
                    
                    <form className="navbar-search">
                        <input
                            type="text"
                            className="bg-base h-40-px w-auto"
                            name="search"
                            placeholder="Search"
                            value={searchQuery}
                            onChange={(e) => setSearchQuery(e.target.value)}
                            onKeyUp={(e) => {
                                if (e.target.value === "") {
                                  setCurrentPage(1);
                                //window.location.reload(); // Reload page only when search is cleared
                                }
                            }}
                        />
                        <Icon icon="ion:search-outline" className="icon" />
                        {searchQuery && (
                        <button
                        onClick={() => {
                          setSearchQuery("");
                          setCurrentPage(1);
                          // Reset your data here if needed
                        }}
                        style={{
                          position: "absolute",
                          insetInlineEnd: "1.9375rem",
                          top: "40%",
                          transform: "translateY(-50%)",
                          fontSize: "1.125rem",
                          color: "var(--black)", // Corrected from `color: var(--black)` which was outside the object
                          background: "transparent",
                          border: "none",
                          cursor: "pointer",
                        }}
                        >
                          <Icon icon="ic:round-close"  />
                        </button>
                      )}
                    </form>
                </div>
            </div>
            <div className="card-body p-24">
                <div className="table-responsive scroll-sm">
                    <table className="table bordered-table sm-table mb-0">
                        <thead>
                            <tr>
                            <th onClick={() => handleSort("_id")} style={{ cursor: "pointer" }}>
                                  Ticket Id
                                  <span className="sort-colume">
                                    <Icon icon="mdi:arrow-up" className={`arrow ${sortColumn === "username" && sortOrder === "asc" ? "active" : ""}`} />
                                    <Icon icon="mdi:arrow-down" className={`arrow ${sortColumn === "username" && sortOrder === "desc" ? "active" : ""}`} />
                                  </span>
                                </th>
                            <th onClick={() => handleSort("firstName")} style={{ cursor: "pointer" }}>
                                  User Name 
                                  <span className="sort-colume">
                                    <Icon icon="mdi:arrow-up" className={`arrow ${sortColumn === "firstName" && sortOrder === "asc" ? "active" : ""}`} />
                                    <Icon icon="mdi:arrow-down" className={`arrow ${sortColumn === "firstName" && sortOrder === "desc" ? "active" : ""}`} />
                                  </span>
                                </th>
                                <th onClick={() => handleSort("userType")} style={{ cursor: "pointer" }}>
                                  User Type 
                                  <span className="sort-colume">
                                    <Icon icon="mdi:arrow-up" className={`arrow ${sortColumn === "userType" && sortOrder === "asc" ? "active" : ""}`} />
                                    <Icon icon="mdi:arrow-down" className={`arrow ${sortColumn === "userType" && sortOrder === "desc" ? "active" : ""}`} />
                                  </span>
                                </th>
                                <th onClick={() => handleSort("title")} style={{ cursor: "pointer" }}>
                                  Title 
                                  <span className="sort-colume">
                                    <Icon icon="mdi:arrow-up" className={`arrow ${sortColumn === "title" && sortOrder === "asc" ? "active" : ""}`} />
                                    <Icon icon="mdi:arrow-down" className={`arrow ${sortColumn === "title" && sortOrder === "desc" ? "active" : ""}`} />
                                  </span>
                                </th>
                            
                                <th onClick={() => handleSort("createdAt")} style={{ cursor: "pointer" }}>
                                  Date{" "}
                                  <span className="sort-colume">
                                    <Icon icon="mdi:arrow-up" className={`arrow ${sortColumn === "createdAt" && sortOrder === "asc" ? "active" : ""}`} />
                                    <Icon icon="mdi:arrow-down" className={`arrow ${sortColumn === "createdAt" && sortOrder === "desc" ? "active" : ""}`} />
                                  </span>
                                </th>
                                <th scope="col" >Status</th>
                                <th scope="col" >Actions</th>
                              
                            </tr>
                        </thead>
                        <tbody>
                        {loading ? (
                <tr>
                  <td colSpan="5" className="text-center">
                    <span className="loader-15"></span>
                  </td>
                </tr>
              ) :items.length > 0 ? (
                items.map((item, index) => (
                                <tr key={item._id}>
                                   <td>{item._id || 'N/A'}</td>
                                   <td>{item.firstName || 'N/A'}</td>
                                   <td>{item.userType ? item.userType.charAt(0).toUpperCase() + item.userType.slice(1) : 'N/A'}</td>

                                   <td>{item.title || 'N/A'}</td>
                                  
                                  
                                   <td>
                                        {(() => {
                                          const date = new Date(item.createdAt);
                                          const day = String(date.getDate()).padStart(2, '0');
                                          const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-indexed
                                          const year = String(date.getFullYear()); 
                                          return `${day}-${month}-${year}`;
                                        })()}
                                      </td>
                                   
                                    <td > 
                                    <span
                                        onClick={() => updateStatus(item._id, item.status)}
                                        className={`${
                                        item.status === 'Open'
                                            ? 'bg-success-focus text-success-600 border border-success-main px-24 py-4 radius-4 fw-medium text-sm' 
                                            : item.status === 'Resolved'
                                            ? 'bg-neutral-200 text-neutral-600 border border-neutral-400 px-24 py-4 radius-4 fw-medium text-sm'
                                            : 'bg-warning'
                                        }`}
                                        style={{ cursor: 'pointer' }} // Add cursor pointer for better UX
                                    >
                                        {item.status.charAt(0).toUpperCase() + item.status.slice(1)}
                                    </span>
                                    </td>
                                    
                                    <td>
                                    <div className="d-flex align-items-center gap-10">
                                    {(!shouldCheckPermissions || canView) && (
                                        <button title='View'
                                        type="button"  onClick={() => navigate(`/supportticket/view/${item._id}`,{ state: { item } })}
                                        className="bg-info-focus bg-hover-info-200 text-info-600 fw-medium w-40-px h-40-px d-flex justify-content-center align-items-center rounded-circle"
                                    >
                                        <Icon
                                            icon="majesticons:eye-line"
                                            className="icon text-xl"
                                        />
                                    </button>
                                      )}
                                     {userrole?.toLowerCase().trim() === 'super_admin' && (
                                        <button
                                          title="Assign to subadmin"
                                          type="button"
                                          onClick={() => { setTicketId(item._id); setSelectTicketData(item.adminId); // Debug: Check ticket ID
                                             setShowModal(true); }}
                                          className="bg-success-focus bg-hover-success-200 text-success-600 fw-medium w-40-px h-40-px d-flex justify-content-center align-items-center rounded-circle"
                                        >
                                          <Icon
                                            icon="mdi-account-arrow-right-outline"
                                            className="icon text-xl"
                                          />
                                        </button>
                                      )}
                                                                          </div>
                                </td>
                                </tr>
                                ))
                            ) : (
                                <tr>
                                <td colSpan="7" className="text-center">
                                    No Data Found
                                </td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>
                <div className="d-flex align-items-center justify-content-between flex-wrap gap-2 mt-24">
                  <span>
                  Showing {(currentPage - 1) * itemsPerPage + 1} to {Math.min(currentPage * itemsPerPage, totalItems)} of {totalItems} entries
                  </span>
                  <ul className="pagination d-flex flex-wrap align-items-center gap-2 justify-content-center">
                    <li className={`page-item ${currentPage === 1 ? "disabled" : ""}`}>
                      <Link
                        className="page-link bg-neutral-200 text-secondary-light fw-semibold radius-8 border-0 d-flex align-items-center justify-content-center h-32-px text-md"
                        to="#"
                        onClick={handlePrev}
                      >
                        <Icon icon="ep:d-arrow-left" />
                      </Link>
                    </li>
                    {getPaginationRange().map((page) => {
                      

                      // Return JSX for pagination items
                      return (
                        <li key={page} className="page-item">
                          <Link
                            className={`page-link text-secondary-light fw-semibold radius-8 border-0 d-flex align-items-center justify-content-center h-32-px w-32-px text-md ${currentPage === page ? "bg-primary-600 text-white" : "bg-neutral-200"}`}
                            to="#"
                            onClick={() => handlePageChange(page)}
                          >
                            {page}
                          </Link>
                        </li>
                      );
                    })}

                 
                    <li className={`page-item ${currentPage === totalPages ? "disabled" : ""}`}>
                   
                      <Link
                        className="page-link bg-neutral-200 text-secondary-light fw-semibold radius-8 border-0 d-flex align-items-center justify-content-center h-32-px text-md"
                        to="#"
                        onClick={handleNext}
                      >
                        <Icon icon="ep:d-arrow-right" />
                      </Link>
                    </li>
                  </ul>
                </div>
                </div>

                     {/* Modal  */}
                     <div class={`custom-modal modal fade ${showModal ? "show" : ""}`}    style={{ display: showModal ? "block" : "none" }} id="exampleModalCenter" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle">
                            <div class="modal-dialog modal-dialog-centered" role="document">
                              <div class="modal-content">
                                <div class="modal-header">
                                  <h5 class="modal-title" id="exampleModalLongTitle">Assign to Sub Admin</h5>
                                  
                                </div>
                                <div class="modal-body">
                                  <form className="row gy-3 needs-validation" noValidate>
                                    <div className="col-md-12">
                                                 <label className="form-label">
                                               Select Sub Admin<span className="text-danger-600">*</span>
                                                      </label>
                                                      <select
                                                      className={`form-control ${errors.selcetedadmin ? "is-invalid" : ""}`}
                                                       value={SelectTicketData || ""} // Set the selected admin, default is empty
                                                      onChange={(e) => {
                                                        setselectedadmin(e.target.value);
                                                        setSelectTicketData(e.target.value);
                                                        setAdminId(e.target.value);
                                                        setErrors((prev) => ({ ...prev, selcetedadmin: "" }));
                                                      }}
                                                      style={{
                                                        fontSize: "16px",
                                                        borderRadius: "7px",
                                                        backgroundPositionX: "unset",
                                                        backgroundPosition: "right 0.75rem center",
                                                      }}
                                                    >
                                                      {/* Default option if no admin is selected */}
                                                      <option value="">Select Sub Admin</option>

                                                      {/* Filter subadmins based on the current ticket's adminId */}
                                                      {subadminData.map((st) => (
                                                        
                                                        <option
                                                          key={st._id}
                                                          value={st._id}
                                                          selected={st._id === SelectTicketData} // Pre-select if adminId matches the ticket's adminId
                                                        >
                                                          {st.name}
                                                        </option>
                                              ))}
                                                      </select>

                                                      {errors.selcetedadmin && (
                                                        <p className="text-danger mt-1">{errors.selcetedadmin}</p>
                                                      )}
                                      </div>
                                  </form>
                                </div>
                                <div class="modal-footer">
                                  <button type="button" class="btn btn-secondary" data-dismiss="modal"  onClick={() => closeModel()} >Close</button>
                                  <button type="submit" class="btn btn-primary"  onClick={() => assigntoadmin(adminId,TicketId)}>Submit</button>
                                </div>
                              </div>
                            </div>
                          </div>
        </div>

    );
};

export default SupportTicketListLayer;